import React from "react";
import { AppConfig } from "../../utils/Constants";

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-default dark:bg-background-dark text-text-primary dark:text-text-primaryDark flex flex-col">
      <header className="py-16 px-6 text-center border-b border-divider dark:border-divider-dark">
        <h1 className="text-5xl font-extrabold text-secondary dark:text-secondary-dark mb-4">
          Terms and Conditions
        </h1>
        <p className="text-lg font-medium text-text-secondary dark:text-text-secondaryDark max-w-3xl mx-auto">
          Please review our terms to understand how{" "}
          {AppConfig.PRODUCT_NAME_SHORT} operates and governs the use of its
          services.
        </p>
      </header>

      <main className="container mx-auto px-6 py-12 space-y-12 max-w-4xl leading-relaxed">
        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            1. Acceptance of Terms
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            By accessing or using {AppConfig.PRODUCT_NAME}, you acknowledge that
            you have read, understood, and agree to be bound by these Terms and
            Conditions. If you do not agree with any of these terms, you must
            discontinue use of our platform immediately.
          </p>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            2. User Responsibilities
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            As a user of {AppConfig.PRODUCT_NAME_SHORT}, you agree to:
          </p>
          <ul className="list-disc list-inside text-lg text-text-secondary dark:text-text-secondaryDark mt-3 space-y-2">
            <li>
              Maintain the confidentiality of your account and credentials.
            </li>
            <li>
              Ensure that any information provided is accurate and up to date.
            </li>
            <li>
              Immediately report unauthorized access or security breaches.
            </li>
            <li>Refrain from using the platform for unlawful activities.</li>
          </ul>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            3. Prohibited Activities
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            You agree not to:
          </p>
          <ul className="list-disc list-inside text-lg text-text-secondary dark:text-text-secondaryDark mt-3 space-y-2">
            <li>
              Use {AppConfig.PRODUCT_NAME} to distribute spam, malware, or
              harmful content.
            </li>
            <li>
              Attempt to bypass security measures or access restricted data.
            </li>
            <li>Engage in fraudulent, deceptive, or misleading practices.</li>
            <li>
              Violate the intellectual property rights of{" "}
              {AppConfig.PRODUCT_NAME_SHORT} or third parties.
            </li>
          </ul>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            4. Intellectual Property
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            All content, branding, and software associated with{" "}
            {AppConfig.PRODUCT_NAME} is the exclusive property of{" "}
            {AppConfig.PRODUCT_NAME_SHORT} Inc. or its licensors. Unauthorized
            use, reproduction, or distribution of our intellectual property is
            strictly prohibited.
          </p>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            5. Termination of Access
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            {AppConfig.PRODUCT_NAME_SHORT} Inc. reserves the right to suspend or
            terminate your account if you are found in violation of these Terms
            and Conditions. This may include, but is not limited to, misuse of
            our platform, illegal activities, or failure to comply with
            applicable laws.
          </p>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            6. Limitation of Liability
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            {AppConfig.PRODUCT_NAME} is provided "as is" without warranties of
            any kind.
            {AppConfig.PRODUCT_NAME_SHORT} Inc. will not be responsible for any
            direct, indirect, incidental, or consequential damages resulting
            from the use of the platform.
          </p>
        </section>
        <div className="border-t border-divider dark:border-divider-dark my-8"></div>

        <section>
          <h2 className="text-2xl font-semibold text-primary dark:text-text-primaryDark mb-2">
            7. Changes to These Terms
          </h2>
          <p className="text-lg text-text-secondary dark:text-text-secondaryDark">
            {AppConfig.PRODUCT_NAME_SHORT} Inc. reserves the right to modify
            these Terms and Conditions at any time. Updates will be posted on
            our platform, and continued use of the service constitutes
            acceptance of the revised terms.
          </p>
        </section>
      </main>

      <footer className="py-10 px-6 text-center text-sm text-text-secondary dark:text-text-secondaryDark">
        <p>
          Questions? Contact{" "}
          <a
            href={`mailto:${AppConfig.SUPPORT_EMAIL}`}
            className="text-secondary hover:underline"
          >
            {AppConfig.SUPPORT_EMAIL}
          </a>
        </p>
        <button
          onClick={() => window.close()}
          className="mt-4 inline-flex items-center px-6 py-2 bg-secondary text-white rounded-lg font-medium shadow-md hover:bg-secondary-dark transition"
        >
          Close Terms
        </button>
      </footer>
    </div>
  );
};

export default Terms;
